var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lms__superadmin_customer_edit_contacts_table"},[_c('component-table',{attrs:{"labels":[
            {
                key: 'name',
                title: 'Name',
                type: 'string',
                sortable: true
            },
            {
                key: ['email', 'phone'],
                title: 'Email / Phone',
                type: 'string',
                sortable: true
            },
            {
                key: 'address',
                title: 'Address',
                type: 'string',
                sortable: true
            },
            {
                key: 'notes',
                title: 'Notes',
                type: 'string',
                sortable: true
            },
            {
                key: 'actions',
                title: '',
                type: '',
                sortable: false
            }
        ],"items":_vm.items,"component-table-item":_vm.LmsSuperadminCustomerEditContactsTableItem},on:{"emit-edit":_vm.emitEdit,"emit-remove":_vm.emitRemove}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }